import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  DestroyRef,
  inject, OnInit,
  Signal, ViewChild,
  viewChild,
  ViewContainerRef
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SupportApiService} from '../../services/support-api.service';
import {BehaviorSubject, catchError, finalize, map, of, switchMap, tap, timer} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {MatFormField, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton, MatIconButton, MatMiniFabButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {AsyncPipe, DatePipe, NgClass, NgStyle} from '@angular/common';
import {ChatMessageInterface, FileAttachmentInterface} from '../../interfaces/http.interface';
import {NgArrayPipesModule, UniquePipe} from 'ngx-pipes';
import {ProgressSpinnerComponent} from '../progress-spinner/progress-spinner.component';
import {SessionStorageService} from 'ngx-webstorage';
import {SafePipe} from '../../pipes/safe.pipe';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {
  SelectTypeFileBottomsheetComponent
} from '../select-type-file-bottomsheet/select-type-file-bottomsheet.component';
import {FileUploadComponentComponent} from '../file-upload-component/file-upload-component.component';
import {GalleryComponent, GalleryItem, ImageItem, VideoItem} from 'ng-gallery';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {SharedDataService} from '../../services/shared-data.service';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {ScrollDirective} from '../../directives/scroll.directive';
import moment from 'moment';
import {ThumbPipe} from '../../pipes/thumb.pipe';

@Component({
  selector: 'app-chat',
  imports: [
    TopBarComponent,
    MatFormField,
    MatInput,
    MatIconButton,
    MatIcon,
    FormsModule,
    AsyncPipe,
    ReactiveFormsModule,
    MatSuffix,
    DatePipe,
    NgStyle,
    NgArrayPipesModule,
    MatButton,
    ProgressSpinnerComponent,
    SafePipe,
    MatProgressSpinner,
    NgClass,
    GalleryComponent,
    MatMiniFabButton,
    CdkTextareaAutosize,
    InfiniteScrollDirective,
    ScrollDirective,
    ThumbPipe
  ],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss',
  providers: [UniquePipe, ThumbPipe]
})
export class ChatComponent implements OnInit {
  @ViewChild(ScrollDirective) private scrollDirective: ScrollDirective | undefined;


  // public messages$: BehaviorSubject<ChatMessageInterface[]> = new BehaviorSubject<ChatMessageInterface[]>([]);
  public messages: ChatMessageInterface[] = [];
  public sendLoading = false;
  public messageLoading = false;
  public items: GalleryItem[] | null = null;
  private currentPage = 1;
  private lockPagination = false;
  private lastMessageUuid: string = '';
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private supportApiService: SupportApiService = inject(SupportApiService);
  private fb: FormBuilder = inject(FormBuilder);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  private bottomSheet: MatBottomSheet = inject(MatBottomSheet);
  public sharedDataService: SharedDataService = inject(SharedDataService);
  public uniquePipe: UniquePipe = inject(UniquePipe);
  public thumbPipe: ThumbPipe = inject(ThumbPipe);
  public vcr: Signal<ViewContainerRef | undefined> = viewChild('container', {read: ViewContainerRef});
  public components: ComponentRef<FileUploadComponentComponent>[] = [];
  // private componentRef?: ComponentRef<FileUploadComponentComponent>
  public orderId = this.sessionStorageService.retrieve('order_id');
  public messageForm: FormGroup = this.fb.group({
    message: [''],
    files: [[]],
    content_type: ['text']
  });
  public isOpened$ = this.route.queryParamMap
    .pipe(
      map(params => ['open', 'pending_service_action', 'in_progress', 'pending_customer_action', 'reopened'].includes(String(params.get('status')))),
      takeUntilDestroyed()
    );
  public chats$ = this.route.queryParamMap
    .pipe(
      tap(() => this.messageLoading = true),
      switchMap(params => {
        return this.supportApiService.getMessages(String(params.get('ticket_uuid')), 1).pipe(finalize(() => this.messageLoading = false));
      }),
      map(data => data?.data),
      tap(data => {
        // this.messages$.next(data.reverse());
        this.messages = data.reverse();
        this.lastMessageUuid = this.messages[this.messages.length - 1].uuid;
        this.cdr.detectChanges();
        this.scrollTo();
      }),
      switchMap(() => {
        if(['open', 'pending_service_action', 'pending_customer_action', 'reopened'].includes(String(this.route.snapshot.queryParamMap.get('status')))) {
          return this.updateMessagesInterval(String(this.route.snapshot.queryParamMap.get('ticket_uuid')))
        } else {
          return of(null);
        }
      }),
      takeUntilDestroyed()
    );
  public sharedLoading$ = this.sharedDataService.sharedLoading$.asObservable();
  public isRelaxTime = false;


  ngOnInit(): void {
    this.isRelaxTime = this.checkRelaxTime();
    this.sharedDataService.sharedLoading$.next(false);
    if(!this.route.snapshot.queryParamMap.has('status')) {
      this.getDetailsTicket(String(this.route.snapshot.queryParamMap.get('ticket_uuid')))
        .pipe(
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe();
    }
  }

  public sendMessage() {
    this.sendLoading = true;
    this.messageForm.get('files')?.setValue(
      this.components
        .filter(c => c.instance.currentFileToUpload)
        .map(c => c.instance.currentFileToUpload)
    );
    this.messageForm.get('content_type')?.setValue('text');
    this.supportApiService.sendMessage(String(this.route.snapshot.queryParamMap.get('ticket_uuid')), this.messageForm.value)
      .pipe(
        tap((resp) => {
          this.messageForm?.reset();
          this.vcr()?.clear();
          this.components = [];
          // this.messages$.next([...this.messages$.value, resp.data]);
          this.messages.push(resp.data);
          this.scrollTo();
        }),
        catchError((err) => {
          return this.getDetailsTicket(String(this.route.snapshot.queryParamMap.get('ticket_uuid')))
        }),
        finalize(() => {
          this.sendLoading = false;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  private updateMessagesInterval(ticket_uuid: string) {
    return timer(3000, 3000).pipe(
      switchMap(params => {
        this.isRelaxTime = this.checkRelaxTime();
        return this.supportApiService.getMessagesAfter(ticket_uuid, this.lastMessageUuid);
      }),
      map(data => data?.data),
      tap(data => {
        // let scrollToBottom = this.messages$.value.length !== data.length;
        let scrollToBottom;
        if(data?.length) {
          scrollToBottom = this.lastMessageUuid !== data[data.length - 1].uuid;
        }
        // this.messages$.next(this.uniquePipe.transform([...this.messages$.value, ...data.reverse()]));
        if(scrollToBottom){
          this.messages = this.uniquePipe.transform([...this.messages, ...data.reverse()], 'uuid');
          this.lastMessageUuid = this.messages[this.messages.length - 1].uuid;
          this.cdr.detectChanges();
          this.scrollTo();
        }
      })
    )
  }

  scrollTo() {
    setTimeout(() => {
      const elem = document.getElementById('chatContent');
      if (elem) {
        elem.scrollTop = elem.scrollHeight;
      }
    }, 100)
  }


  openReason(planningStatus: 'close' | 'reopen') {
    this.router.navigate(['/ticket-reason'] , {queryParams: {
      ticket_uuid: this.route.snapshot.queryParamMap.get('ticket_uuid'),
      planningStatus
    }});
  }

  openBottomSheet(): void {
    this.bottomSheet.open(SelectTypeFileBottomsheetComponent, {
      autoFocus: false,
      panelClass: 'bottom-sheet-file-type',
    })
      .afterDismissed()
      .pipe(
        tap((result) => {
          if(result) {
            this.createComponent(result);
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  private createComponent(typeFile: string) {
    const vcr = this.vcr();
    if (!vcr) return;

    const componentRef = vcr.createComponent(FileUploadComponentComponent);
    componentRef?.setInput('typeFile', typeFile);
    componentRef?.setInput('sendLoading', this.sendLoading);
    componentRef.instance.getIndex = () => this.getComponentIndex(componentRef);
    componentRef.instance.remove = () => this.removeComponent(componentRef);
    componentRef.instance.loadingChange
      .pipe(
        tap((loading) => this.checkLoadingImage()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe()

    this.components.push(componentRef);
    if(this.components.length === 1) {
      this.scrollTo();
    }
    this.cdr.detectChanges();
  }

  getComponentIndex(componentRef: ComponentRef<FileUploadComponentComponent>): number {
    return this.components.indexOf(componentRef);
  }

  removeComponent(componentRef: ComponentRef<FileUploadComponentComponent>) {
    const index = this.getComponentIndex(componentRef);
    if (index !== -1) {
      componentRef.destroy();
      this.components.splice(index, 1);
    }
  }

  private checkLoadingImage() {
    this.sharedDataService.sharedLoading$.next(this.components.some(c => c.instance.loading));
  }


  openGallery(files: FileAttachmentInterface[] | undefined) {
    if(!files) return;
    this.items = files
      .filter(el => el.file_type === 'image' || el.file_type === 'video')
      .map(file => {
        if(file.file_type === 'image') {
          return new ImageItem({
            type: 'image',
            src: file.url,
          });
        } else {
          return new VideoItem({
            type: 'video',
            disablePictureInPicture: true,
            disableRemotePlayback: true,
            // autoplay: true,
            controls: true,
            src: file.url,
            poster: this.thumbPipe.transform(file.url) || ''
          })
        }
    });
    console.log('/hideAppExit')
    this.cdr.detectChanges();
  }

  closeGallery() {
    this.items = null
    console.log('/showAppExit')
    this.cdr.detectChanges();
  }

  private getDetailsTicket(uuid: string) {
    return this.supportApiService.getTicketDetails(
      String(uuid))
      .pipe(
        map(data => data?.data),
        tap(data => {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { status: data.status },
            queryParamsHandling: 'merge' // Зберігає інші параметри
          });
        }),
      );
  }

  onScrollUp() {
    if(!this.lockPagination) {
      this.lockPagination = true;
      this.currentPage++;
      this.supportApiService.getMessages(String(this.route.snapshot.queryParamMap.get('ticket_uuid')), this.currentPage).pipe(
        map(data => data?.data),
        tap(data => {
          if(data.length === 0) {
            this.currentPage--;
          } else {
            this.scrollDirective?.prepareFor('up');
            const newData = data.reverse().filter(el => !this.messages.some(m => m.uuid === el.uuid));
            this.messages.unshift(...newData);
            this.cdr.detectChanges();
            setTimeout(() => this.scrollDirective?.restore());
          }
        }),
        finalize(() => {
          setTimeout(() => {
            this.lockPagination = false
          }, 100);
        }),
        takeUntilDestroyed(this.destroyRef)
      ).subscribe()
    }
  }

  public checkRelaxTime() {
      const now = moment();
      const day = now.day();
      const hour = now.hour();
      const minute = now.minute();
      if (day === 0 || day === 6) {
        return true;
      }
      const startOfWork = moment().hour(9).minute(0);
      const endOfWork = moment().hour(17).minute(59);
      return !(now.isBetween(startOfWork, endOfWork, undefined, '[]'));
  }
}
